window.fisherAnalytics.myList = {
    version: '1.0.0',
    process: function (body, response, config) {
        if (response.responseText.indexOf(config.responseText) !== -1) {
            try {
                window.fisherAnalytics.utils.log('XHR request to specific create list URL with specific response detected!', config.responseText);

                if (response.status === 200) {
                    document.dispatchEvent(new CustomEvent("newListbulkUploadSucess", {}));

                } else {
                    document.dispatchEvent(new CustomEvent("newListbulkUploadError", {"error": response.message}));
                }
            } catch (e) {
                window.fisherAnalytics.utils.log("issue with My List data global ui intercept: " + e);
            }
        }
    },
    processAddToList: function (body, response, config) {
        let _url = response._url;
        if (response.responseText.indexOf(config.responseText) !== -1) {
            try {
                window.fisherAnalytics.utils.log('XHR request to specific add to list URL with specific response detected!', config.responseText);

                if (response.status === 200 || response.status === 204) {
                    //We need to get the list ID from the url like /store1/mylist/service/addtolist/items/23383751/NEW_MYLIST
                    const urlParts = _url.split('/');
                    const listIdIndex = urlParts.findIndex(part => part === 'items') + 1;
                    const listId = urlParts[listIdIndex];

                    //update env.temporaryDetails with list name and ID.  NOTE - list name is not available here and comes from setListName function
                    if(env.temporaryDetails){
                        if(env.temporaryDetails.detail) {
                            if(env.temporaryDetails.detail.list){
                                env.temporaryDetails.detail.list.id = listId;
                            } else {
                                env.temporaryDetails.detail.list = {
                                    id: listId
                                }
                            }
                            document.dispatchEvent(new CustomEvent("addToList", env.temporaryDetails));
                        }
                    }
                } else {
                    document.dispatchEvent(new CustomEvent("addToListError", {"error": response.message}));
                }
            } catch (e) {
                window.fisherAnalytics.utils.log("issue with My List data global ui intercept: " + e);
            }
        }
    },
    processCreateList: function (body, response, config) {
        let bodyJson;
        let responseJson;
        if (response.responseText.indexOf(config.responseText) !== -1) {
            try {
                window.fisherAnalytics.utils.log('XHR request to specific create list URL with specific response detected!', config.responseText);
                let customEvent = 'createNewList';
                if (response.status === 200 || response.status === 204) {
                    if(response.status === 204){
                        customEvent = 'addToList';
                    }
                    bodyJson = JSON.parse(body);
                    responseJson = JSON.parse(response.responseText);
                    //update env.temporaryDetails with list name and ID
                    if(env.temporaryDetails){
                        if(env.temporaryDetails.detail) {
                            env.temporaryDetails.detail.list = {
                                name: bodyJson.form.listTitle,
                                id: responseJson.attr[0].listId
                            }
                            document.dispatchEvent(new CustomEvent(customEvent, env.temporaryDetails));
                        }
                    }
                }
            } catch (e) {
                window.fisherAnalytics.utils.log("issue with My List data global ui intercept: " + e);
            }
        }
    },
    processCreateListFromMyListPage: function (body, response, config) {
        let bodyJson;
        let responseJson;
        if (response.responseText.indexOf(config.responseText) !== -1) {
            try {
                window.fisherAnalytics.utils.log('XHR request to specific create empty list URL with specific response detected!', config.responseText);
                if (response.status === 200 ) {
                    bodyJson = JSON.parse(body);
                    responseJson = JSON.parse(response.responseText);
                    //update env.temporaryDetails with list name and ID and remove products
                    env.temporaryDetails = env.temporaryDetails || {};
                    env.temporaryDetails.detail = env.temporaryDetails.detail || {};
                    delete env.latestListId; // to prevent sending latestListId when creating empty list
                    delete env.temporaryDetails.detail.products; // to prevent sending products when creating empty list
                    delete env.creatingNewListFromMyListPage;
                    env.temporaryDetails.detail.list = {
                        name: bodyJson.title,
                        id: responseJson.attr[0].listId
                    }
                    env.latestListId = responseJson.attr[0].listId || null; // flag to indicate list was created from My List page
                    env.creatingNewListFromMyListPage = true; // flag to indicate list was created from My List page
                }
            } catch (e) {
                window.fisherAnalytics.utils.log("issue with My List data global ui intercept: " + e);
            }
        }
    },
    processRemoveItemFromList: function (body, response, config) {
        let _url = response._url;
        if (response.responseText.indexOf(config.responseText) !== -1) {
            try {
                window.fisherAnalytics.utils.log('XHR request to specific add to list URL with specific response detected!', config.responseText);

                if (response.status === 200 || response.status === 204) {
                    //We need to get the list ID from the url like /store1/mylist/service/item/5396248/list/24391704
                    const urlParts = _url.split('/');
                    const listIdIndex = urlParts.findIndex(part => part === 'list') + 1;
                    const listId = urlParts[listIdIndex];

                    //update env.temporaryDetails with list name and ID.  NOTE - list name is not available here and comes from setListName function
                    if(env.temporaryDetails){
                        if(env.temporaryDetails.detail) {
                            if(env.temporaryDetails.detail.list){
                                env.temporaryDetails.detail.list.id = listId;
                            } else {
                                env.temporaryDetails.detail.list = {
                                    id: listId
                                }
                            }
                            document.dispatchEvent(new CustomEvent("removeItemFromList", env.temporaryDetails));
                        }
                    }
                } else {
                    document.dispatchEvent(new CustomEvent("removeItemFromListError", {"error": response.message}));
                }
            } catch (e) {
                window.fisherAnalytics.utils.log("issue with My List data global ui intercept: " + e);
            }
            delete env.temporaryDetails; // reset temporary details after share
        }
    },
    setBulkUploadListFlag : function(body, response, config){
        env.isBulkUploadList = true;
    },
    processBulkUploadToList : function (body, response, config) {
        if(!env.isBulkUploadList){
            return;
        }
        //reset flag
        delete env.isBulkUploadList;
        //this same endpoint lists items in a list, we only want created events
        let _url = response._url;
        let bulkResponse;
        let badges = [];
        //handle bulk upload products
        let _setProductDataForBulk = function(data){
            env.temporaryDetails.detail.products = data.content.map(item => {
                return {
                    discount: "",
                    familyId: item.catalogNumber,
                    name: item.productTitleNoGlyphs,
                    price: parseFloat(item.uoms ? item.uoms[0].price.replace(/[^\d.-]/g, ''): 0.00),
                    sku: item.catalogNumber,
                    variation: item.uoms ? item.uoms[0].displayUnitString : "",
                    type: digitalData.page.type,
                    badges: item.badgesList,
                    glyphs: []
                };
            });
        }

        if (response.responseText.indexOf(config.responseText) !== -1) {
            env.temporaryDetails = env.temporaryDetails || {};
            bulkResponse = JSON.parse(response.responseText) || {};
            //When lists get created from My List page, this endpoint is always called, but it's not always a new list
            if(env.creatingNewListFromMyListPage){
                //If we have a latestListId and the response listId matches, then it's a new list with an upload.
                if(env.latestListId){
                    //check to see if the listId in the response matches the latestListId and the content[] has items
                    if(bulkResponse.listId && bulkResponse.listId === env.latestListId && bulkResponse.content && bulkResponse.content.length > 0){
                        //We need to update the products array and add it to env.temporaryDetails to have all the products in the list

                        env.temporaryDetails.detail = env.temporaryDetails.detail || {};
                        _setProductDataForBulk(bulkResponse);
                    }
                }
                document.dispatchEvent(new CustomEvent('createNewList', env.temporaryDetails));
                //reset flags
                delete env.latestListId;
                delete env.creatingNewListFromMyListPage;
            } else {
                //not creating a new list, so just a bulk upload to an existing list
                if(env.temporaryDetails){
                    env.temporaryDetails.detail = env.temporaryDetails.detail || {};
                    _setProductDataForBulk(bulkResponse);
                    if(env.temporaryDetails.detail.list){
                        env.temporaryDetails.detail.list.id = bulkResponse.listId;
                        window.fisherAnalytics.myListObserver.setListName();
                    } else {
                        window.fisherAnalytics.myListObserver.setListName();
                        env.temporaryDetails.detail.list = {
                            id: bulkResponse.listId
                        }
                    }
                    document.dispatchEvent(new CustomEvent("addToList", env.temporaryDetails));
                }
            }
        }
    },
    processAcceptShareList: function (body, response, config) {
        let _url = response._url;
        let eventName = 'shareList';
        let listId;
        let responseJson;
        env.temporaryDetails = env.temporaryDetails || {};
        env.temporaryDetails.detail = env.temporaryDetails.detail || {};
        if (response.responseText.indexOf(config.responseText) !== -1) {
            try {
                window.fisherAnalytics.utils.log('XHR request to specific share list URL with specific response detected!', config.responseText);

                if (response.status === 200 || response.status === 201) {
                    responseJson = JSON.parse(response.responseText);
                    window.fisherAnalytics.myListObserver.setListName();
                    if(response.status === 200){
                        //We need to get the list ID from the url like /store1/mylist/service/share/24391704
                        let urlParts = _url.split('/');
                        let listIdIndex = urlParts.findIndex(part => part === 'share') + 1;
                        listId = urlParts[listIdIndex];
                    }

                    if(response.status === 201){
                        eventName = 'acceptList';
                        listId = responseJson.listId;
                    }


                    //update env.temporaryDetails with list name and ID.  NOTE - list name is not available here and comes from setListName function
                    if(env.temporaryDetails.detail.list){
                        env.temporaryDetails.detail.list.id = listId;
                    } else {
                        env.temporaryDetails.detail.list = {
                            id: listId
                        }
                    }
                    document.dispatchEvent(new CustomEvent(eventName, env.temporaryDetails));
                } else {
                    document.dispatchEvent(new CustomEvent("shareListError", {"error": response.message}));
                }
            } catch (e) {
                window.fisherAnalytics.utils.log("issue with My List data global ui intercept: " + e);
            }
            delete env.temporaryDetails; // reset temporary details after share
        }
    },

    setPageTabName: function () {
        let tabName = window.fisherAnalytics.myListObserver.getActiveTabName();
        let finalTabName = "My Lists";
        window.digitalDataManager.setPageName(finalTabName + ':' + tabName);
    }
};